import { Component, OnDestroy, OnInit } from "@angular/core";
import {
  NbMediaBreakpointsService,
  NbMenuService,
  NbSidebarService,
  NbThemeService,
} from "@nebular/theme";
import { NbWindowService, NbWindowState } from "@nebular/theme";
import { Router } from "@angular/router";

import { AuthService } from "../../../services/auth.service";
import { UserData, User } from "../../../@core/data/users";
import { LayoutService } from "../../../@core/utils";
import { map, takeUntil } from "rxjs/operators";
import { Subject } from "rxjs";
import { UserService } from "../../../@core/api/users.service";
import { LenguageService } from "../../../@core/utils/lenguage.service";
import { Notification } from "../../../@core/data/notification";
import { NotificationService } from "../../../@core/api/notification.service";
import { NotificationsComponent } from "../../../@components/notifications/notifications.component";

@Component({
  selector: "ngx-header",
  styleUrls: ["./header.component.scss"],
  templateUrl: "./header.component.html",
})
export class HeaderComponent implements OnInit, OnDestroy {
  private destroy$: Subject<void> = new Subject<void>();
  notifications: Notification[] = [];
  userPictureOnly: boolean = false;
  user: User;
  promotion: any;

  currentTheme = "default";

  userMenu = [{ title: "Log out" }];

  constructor(
    private router: Router,
    private language: LenguageService,
    private notificationService: NotificationService,
    private sidebarService: NbSidebarService,
    private windowService: NbWindowService,
    private menuService: NbMenuService,
    private themeService: NbThemeService,
    private userService: UserService,
    private layoutService: LayoutService,
    private authService: AuthService,
    private breakpointService: NbMediaBreakpointsService
  ) {}

  async ngOnInit() {
    this.init();
    this.userService.subscribeToUpdate().subscribe((data) => {
      this.init();
    });
  }

  async init() {
    this.currentTheme = this.themeService.currentTheme;

    this.user = <User>await this.userService.getCurrentUser();

    const { xl } = this.breakpointService.getBreakpointsMap();
    this.themeService
      .onMediaQueryChange()
      .pipe(
        map(([, currentBreakpoint]) => currentBreakpoint.width < xl),
        takeUntil(this.destroy$)
      )
      .subscribe(
        (isLessThanXl: boolean) => (this.userPictureOnly = isLessThanXl)
      );

    this.themeService
      .onThemeChange()
      .pipe(
        map(({ name }) => name),
        takeUntil(this.destroy$)
      )
      .subscribe((themeName) => (this.currentTheme = themeName));

    this.menuService.onItemClick().subscribe(({ item }) => {
      switch (item.title) {
        case "Log out":
          this.authService.logout();
          this.router.navigate(["/"]);
          break;

        default:
          break;
      }
    });

    setInterval(() => {
      this.getNotifications();
    }, 30000);

    this.getNotifications();
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  changeTheme(themeName: string) {
    this.themeService.changeTheme(themeName);
  }

  toggleSidebar(): boolean {
    this.sidebarService.toggle(true, "menu-sidebar");
    this.layoutService.changeLayoutSize();

    return false;
  }

  gotoProfile() {
    this.router.navigate(["/home/profile"]); // define your component where you want to go
  }

  async getNotifications() {
    this.notifications = <Notification[]>(
      await this.notificationService.getNotifications()
    );
  }

  openNotifications() {
    this.windowService
      .open(NotificationsComponent, { title: "Notifiche" })
      .onClose.subscribe(() => this.getNotifications());
  }

  navigateHome() {
    this.menuService.navigateHome();
    return false;
  }
}
